import React from 'react';
import useBreadcrumbs from 'use-react-router-breadcrumbs';

import { Breadcrumbs } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { useRoutes } from '@common/components/app-layout/breadcrumb-context';

const AppBreadcrumbs = () => {
  const routes = useRoutes();
  const breadcrumbs = useBreadcrumbs(routes);

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{
        '& .MuiBreadcrumbs-li': {
          typography: 'body2',
          fontSize: 'small'
        }
      }}
    >
      {breadcrumbs.map(({ breadcrumb, key, location }) => {
        return key !== location.pathname ? breadcrumb : null;
      })}
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
